import { connect } from 'react-redux';
import React, { Component } from 'react'
import { logOut } from "./AuthActions";
import { openOverlay, closeOverlay } from './OverlayActions';
import './Menu.css';
import { navNewURL } from './ActionUtils'
import { selectNavDropdown } from "./MenuActions";
import { shortenAddress } from './ActionUtils';
import { getMenuTokens } from './TokenUtils';
import { shared } from '../Shared';
import { track, addCommasToNumber } from './ActionUtils';
import logoImageWhiteBG from "../logo_modified.svg";
import logoOnlyWhiteBG from "../logo_only.svg";
//import addMenuImg from "../add_darkgrey.png";
//import notificationsMenuImg from "../notifications_darkgrey.png";
import feedbackImg from "../chat_white.png";
import NavIcon from "./NavIcon";
import Link from './Link';
import { getIsMobile } from './ActionUtils';

class Menu extends Component {
  constructor(props, context) {
    super(props);

      // This binding is necessary to make `this` work in the callback
      this.navigate = this.navigate.bind(this);
      this.navigateBack = this.navigateBack.bind(this);
      this.navigateMenu = this.navigateMenu.bind(this);
      this.navigateLogo = this.navigateLogo.bind(this);
      this.navigateDialog = this.navigateDialog.bind(this);
      this.logIn = this.logIn.bind(this);
      this.logOut = this.logOut.bind(this);
      this.submitFeedback = this.submitFeedback.bind(this);
      this.testMode = this.testMode.bind(this);
      this.showAddressInfo = this.showAddressInfo.bind(this);
      this.handleTestMsgClick = this.handleTestMsgClick.bind(this);
      this.openLoginDialog = this.openLoginDialog.bind(this);
      this.handleNavClick = this.handleNavClick.bind(this);
      this.handleDropdownClick = this.handleDropdownClick.bind(this);
  }

  navigate(event, track_type) {
    let pathname = event.currentTarget.getAttribute("name");
    if (pathname === "home") {
      pathname = "";
    }

    let link = "";
    if (event.currentTarget.hasAttribute("link")) {
      link = event.currentTarget.getAttribute("link");
    }

    this.props.dispatch(track("action", "button", JSON.stringify({name: pathname, type: track_type})));

    event.preventDefault();
    if (this.props.auth.confirmNav) {
      this.props.dispatch(openOverlay("confirm", {pathname: pathname, query: {}, title: "Are you sure?", message: "Do you want to cancel and discard all changes?"}));
    }
    else {
      if (pathname === "back") {
        window.oldHref = window.location.href;
        window.history.back();
        window.setTimeout(() => {
          if (window.oldHref === window.location.href) {
            this.props.dispatch(navNewURL('/'));
          }
        }, 300);
      }
      else {
        if (link === "") {
          link = '/' + pathname;
        }

        this.props.dispatch(navNewURL(link));
      }
    }
  }
  
  handleDropdownClick(event, action) {
    if (action === "logout") {
      this.logOut();
    }
    else {
      this.navigateMenu(event);
    }
  }

  navigateMenu(event) {
    this.navigate(event, "menu_navigate");
  }

  navigateLogo(event) {
    this.navigate(event, "logo_navigate");
  }

  navigateBack(event) {
    this.navigate(event, "back_navigate");
  }

  navigateDialog(event) {
    this.navigate(event, "dialog_navigate");
    this.props.dispatch(closeOverlay());
  }

  submitFeedback(event) {
    this.props.dispatch(track("action", "button", JSON.stringify({name: "report", type: "menu_navigate"})));
    this.props.dispatch(openOverlay("report", {}));
  }

  testMode(event) {
    this.props.dispatch(track("action", "button", JSON.stringify({name: "testmode", type: "menu_navigate"})));
    let testMode = this.props.auth.testMode;
    this.props.dispatch(openOverlay("testmode", {mode: (testMode ? "test":"prod") }));
  }

  showAddressInfo(event) {
    this.props.dispatch(track("action", "button", JSON.stringify({type:"menu_show_address_info"})));

    let selectedAddress = this.props.auth.ethAddress;
    let authUsername = this.props.auth.username;
    let hasUsernameMatch = this.props.auth.hasUsernameMatch;
    let hasAccount = this.props.auth.hasAccount;
    let isDisabled = this.props.auth.isDisabled;
    //let shortSelectedAddress = shortenAddress(selectedAddress);
    let title = "Your Ethereum wallet";

    let flagWrongNetwork = false;
    let ethNetwork = this.props.auth.ethNetwork;
    let ethNetworkName = this.props.auth.ethNetworkName;
    if (ethNetwork !== "" && !shared.isSupportedNetwork(ethNetwork)) {
      flagWrongNetwork = true;
    }

    if (flagWrongNetwork) {
      title = "Unsupported network";
      this.props.dispatch(openOverlay("message", {title, message:"Please change your Ethereum wallet to use the " + shared.getNetworkNameLong(false) + " or " + shared.getNetworkNameLong(true) + ". You are currently using the " + ethNetworkName + "."}));
    }
    else if (hasAccount && hasUsernameMatch && isDisabled) {
      this.props.dispatch(openOverlay("message", {title, message:<span>{"Ethereum address "}{<span style={{fontWeight:"bold"}}>{selectedAddress}</span>}{" is linked with your Atstake account "}{<span style={{fontWeight:"bold"}}>{authUsername}</span>}{". It has been disabled and cannot be used to log in."}</span>}));
    }
    else if (hasAccount && hasUsernameMatch) {
    this.props.dispatch(openOverlay("message", {title, message:<span>{"Ethereum address "}{<span style={{fontWeight:"bold"}}>{selectedAddress}</span>}{" is linked with your Atstake account "}{<span style={{fontWeight:"bold"}}>{authUsername}</span>}{"."}<br/><br/><span>{" You are currently using the " + ethNetworkName + "."}</span></span>}));
    }
    else if (hasAccount) {
      this.props.dispatch(openOverlay("message", {title, message:<span>{"Ethereum address "}{<span style={{fontWeight:"bold"}}>{selectedAddress}</span>}{" is linked with a different Atstake account."}<br/><br/>{"You may want to "}<span className="bluelink" name="account" onClick={this.openLoginDialog}>log in with that account</span>{", or switch to a different Ethereum address."}</span>}));
    }
    else {
      this.props.dispatch(openOverlay("message", {title, message:<span>{"Ethereum address "}{<span style={{fontWeight:"bold"}}>{selectedAddress}</span>}{" is not linked with any Atstake account. Visit the "}<span className="blacklink" name="profile" onClick={this.navigateDialog}>Profile page</span>{" if you'd like to link it."}</span>}));
    }
  }

  handleTestMsgClick(event) {
    let testMode = this.props.auth.testMode;
    this.props.dispatch(openOverlay("testmode", {mode: (testMode ? "test":"prod") }));
  }

  logIn(event) {
    this.props.dispatch(track("action", "button", JSON.stringify({type:"log_in"})));
    // Always show the site's dialog before asking the wallet for a signature.
    this.props.dispatch(openOverlay("login", {}));
  }

  logOut(event) {
    this.props.dispatch(track("action", "button", JSON.stringify({type:"log_out"})));
    this.props.dispatch(logOut());
  }

  openLoginDialog(event) {
    this.props.dispatch(openOverlay("login", {}));
  }

  handleNavClick(action) {
    this.props.dispatch(selectNavDropdown(action));
  }

  render() {  
    
    let ethBalance = this.props.auth.ethBalance;
    let erc20Balances = this.props.auth.erc20Balances;
    let hasShortScreen = this.props.auth.screenDimensions.height < 500;

    let { selectedPage="" } = this.props.menu;
    let { status="pending" } = this.props.auth;
    let selectedAddress = this.props.auth.ethAddress;
    let shortSelectedAddress = shortenAddress(selectedAddress);

    let backText = "Back";
    let showBack = false;
    let backPath = "back";
    if (this.props.auth.navParam === "contracts") {
      backPath = "contracts";
      backText = "Contracts";
    }

    if (selectedPage === "view" || selectedPage === "new" || selectedPage === "edit") {
      showBack = true;
    }
    else if (selectedPage === "contracts") {
      let { filter="" } = this.props.menu.queryParams;
      if (filter !== "") {
        showBack = true;
      }
    }
    else if (selectedPage === "ratings") {
      showBack = true;
    }

    if (status === "loggedout") {
      showBack = false;
    }

    let authUsername = this.props.auth.username;
    let hasUsernameMatch = this.props.auth.hasUsernameMatch;
    let hasAccount = this.props.auth.hasAccount;
    let isDisabled = this.props.auth.isDisabled;
    let initCheckAddress = this.props.auth.initCheckAddress;

    let flagAddress = false;
    if (initCheckAddress) {
      flagAddress = !hasUsernameMatch || !hasAccount || isDisabled;
    }

    let flagWrongNetwork = false;
    let ethNetwork = this.props.auth.ethNetwork;
    let ethNetworkName = this.props.auth.ethNetworkName;
    if (initCheckAddress && ethNetwork !== "" && !shared.isSupportedNetwork(ethNetwork)) {
      flagWrongNetwork = true;
    }

    let flagNoAddress = false;
    if (initCheckAddress && selectedAddress === "") {
      flagNoAddress = true;
    }

    let unreadMessageCount = this.props.auth.unreadCount;

    let menuTokens = getMenuTokens();
    let balanceElem = [];
    if (initCheckAddress) {
      if (flagWrongNetwork) {
        balanceElem.push(<div key="wrongnetwork" className="balanceInfo" style={{height:"40px"}}><span onClick={initCheckAddress ? this.showAddressInfo : null} style={{fontWeight:"bold", color:"#ff7766", cursor:"pointer"}}>Unsupported Network</span></div>);
      }
      else if (flagNoAddress) {
        // Nothing
      }
      else {
        for (let i = 0; i < menuTokens.length; i++) {
          let tokenSymbol = menuTokens[i];
          let tokenSymbolUpper = tokenSymbol.toUpperCase();
          let balanceFixed = "";
    
          if (tokenSymbol === "eth") {
            if (ethBalance) {
              balanceFixed = Math.floor(parseFloat(ethBalance)*100)/100;
            }
          }
          else {
            if (erc20Balances.hasOwnProperty(tokenSymbolUpper)) {
              let tokenBalance = erc20Balances[tokenSymbolUpper].balance;
              balanceFixed = Math.floor(parseFloat(tokenBalance)*100)/100;
            }
          }
    
          let balanceWithCommas = addCommasToNumber(balanceFixed);
          if (balanceFixed !== "") {
            balanceElem.push(<div key={i} className="balanceInfo" style={{marginTop: (i === 0 && !hasShortScreen ? "8px" : "")}}>{tokenSymbolUpper + ": " + balanceWithCommas}</div>);
          }
        }
      }
    }

    let isMobile = getIsMobile();
    let selectedNavMenu = this.props.menu.selectedNavMenu;
    const homeLink = (
      <a className="menuPageLink menuHomeLink" href="/" aria-current={selectedPage === 'home' || selectedPage === '' ? 'page' : undefined}>
        Home
      </a>
    );
    const helpLink = (
      <a className="menuPageLink menuHelpLink" href="/help" aria-current={selectedPage === 'help' ? 'page' : undefined}>
        Help
      </a>
    );

    let profileElem = (
      <div>
        <div className="menuProfileUsername">{authUsername}</div>
        {initCheckAddress && <div onClick={this.showAddressInfo} style={{cursor:"pointer"}} className={"menuProfileWallet"}>
          {initCheckAddress ? (<span>{shortSelectedAddress}</span>) : (<span>&nbsp;</span>)}
          {initCheckAddress && flagNoAddress && <div style={{padding: "0px 0px 8px 0px", fontWeight: "bold", fontSize: "12px", textAlign: "center"}}>ETH wallet disconnected</div>}
          {initCheckAddress && !flagNoAddress && <div style={{padding: "0px 0px 8px 0px", fontWeight: "bold", fontSize: "12px", textAlign: "center"}}>{ethNetworkName}</div>}
          {initCheckAddress && !flagNoAddress && !flagWrongNetwork && flagAddress && <div style={{padding: "0px 0px 8px 0px", fontWeight: "bold", fontSize: "12px", textAlign: "center"}}>{hasAccount ? "Ethereum address linked to different Atstake account" : "Ethereum address not linked"}</div>}
        </div>}
        {balanceElem.length > 0 && <div className="menuProfileBalance">{balanceElem}</div>}
      </div>
    );
    
    return (
      <div>
        <div>
          <div className={'newMenuBar' + (showBack ? ' menuHasBack' : '') + (status === 'loggedin' ? ' menuLoggedIn' : '')}>
            <div className="newMenuInner">
              {!showBack && !isMobile && (
                <Link href={"/"} noTarget={true} rel="noopener noreferrer">
                  <img name="home" onClick={null} className="logoImg" src={logoImageWhiteBG} alt="Atstake" />
                </Link>
              )}
              {!showBack && isMobile && (
                <Link href={"/"} noTarget={true} rel="noopener noreferrer">
                  <img name="home" onClick={null} className="logoImg" src={status === 'loggedin' ? logoImageWhiteBG : logoOnlyWhiteBG} alt="Atstake" />
                </Link>
              )}
              {showBack && (
                <button type="button" name={backPath} onClick={this.navigateBack} className="backBtn menuPageLink">❮ {backText}</button>
              )}
            </div>
            { status === "loggedin" && (
              <nav className="menuAccountActions" aria-label="Main navigation">
                {homeLink}
                <NavIcon active={['contracts', 'new', 'edit', 'view'].includes(selectedPage)} label="Contracts" action="contracts" />
                <NavIcon active={selectedPage === 'people'} label="People" action="people" />
                <NavIcon active={selectedPage === 'messages'} label="Messages" action="messages" notifyCount={unreadMessageCount} />
                <NavIcon active={['profile', 'ratings', 'balances'].includes(selectedPage)} label="You" action="profile" showDropdown={selectedNavMenu === "profile"} menuTop={profileElem} menuList={[{label:"Profile", action:"profile"}, {label:"Contracts", action:"contracts"}, {label:"Ratings", action:"ratings"}, {label:"Wallet", action:"balances"}, {label:"Log out", action: "logout"}]} onMenuClick={this.handleNavClick} onNavigateMenu={this.handleDropdownClick} />
                {helpLink}
              </nav>
              )
            }
            { status === "loggedout" && (
                <nav className="menuPublicActions" aria-label="Main navigation">
                  {homeLink}
                  {helpLink}
                  <button type="button" onClick={this.logIn} className="menuAuthButton">
                    {hasAccount ? "Log in" : "Sign up"}
                  </button>
                </nav>
              )
            }
          </div>
          <div className="menuPlaceholder"></div>
        </div>

        <div>
          <div className="feedbackPrompt">
            <div className="feedbackCircle">
              <img name="feedback" onClick={this.submitFeedback} className="feedbackImg" src={feedbackImg} alt="Feedback" />
            </div>
          </div>
        </div>
     </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.auth,
    menu: state.menu
  }
}

const MenuContainer = connect(mapStateToProps, null)(Menu);
export default MenuContainer;
